import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sort", "category", "per"]
  static values = { categories: Object }

  sortChanged() {
    this.#selectRadio("sort", this.sortTarget.value)
  }

  perChanged() {
    this.#selectRadio("per", this.perTarget.value)
  }

  categoryChanged() {
    const selectedMediums = this.categoriesValue[this.categoryTarget.value] || []
    const checkboxes = document.querySelectorAll('input[type="checkbox"][name="medium[]"]')
    if (!checkboxes.length) return

    checkboxes.forEach((cb) => {
      cb.checked = selectedMediums.includes(cb.value)
      const img = cb.closest("label")?.querySelector("img[data-checked-src]")
      if (img) img.src = cb.checked ? img.dataset.checkedSrc : img.dataset.uncheckedSrc
    })

    checkboxes[0].dispatchEvent(new Event("change", { bubbles: true }))
  }

  // Mirror a native <select> choice onto the hidden radio the form actually submits.
  #selectRadio(name, value) {
    const radio = document.querySelector(`input[type="radio"][name="${name}"][value="${value}"]`)
    if (!radio) return

    radio.checked = true
    radio.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
